let apidaePrestaFairGuestLite = {

    props: {
        prestaItem: Object,
        uri: String
    },
    computed: {
    },
    components: {},
    directives: {},
    data() {
        return {
            fairguestApiUrl: 'https://api.tourism-system.com',
            fairguestApiLitePrivate: '/widgets/public/fairguest/sheetslite',
            fairguestApiDetail: '/widgets/public/fairguest/sheets',
            fairguestApiUsername: 'fg-paca-adt-var_fairguestapi',
            fairguestApiPassword: '(9rWezLV',
            fairguestApiGroup: '596',
            fairguestApiPrefixeFicheSource: 'sitra2i-CRTPACA-',
            fairguestItem: {}
        }
    },
    methods: {
    },
    mounted: function() {
        let query = `?fairguest_group=${this.fairguestApiGroup}&idFicheSource=${this.fairguestApiPrefixeFicheSource}${this.prestaItem.prestaVO.idPrestation}`
        let headers = new Headers()
        headers.set("Content-Type", "application/json")
        headers.set('Authorization', 'Basic ' + btoa(this.fairguestApiUsername + ":" + this.fairguestApiPassword))
        headers.set('Access-Control-Allow-Origin', '*')
        fetch(this.fairguestApiUrl + this.fairguestApiDetail + query, {
                method: 'GET',
                headers: headers
            })
            .then(stream => stream.json())
            .then(data => {
                this.fairguestItem = data
                this.percentageRating1 = Math.round((data.fairguest_counts.count_rating_1 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating2 = Math.round((data.fairguest_counts.count_rating_2 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating3 = Math.round((data.fairguest_counts.count_rating_3 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating4 = Math.round((data.fairguest_counts.count_rating_4 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating5 = Math.round((data.fairguest_counts.count_rating_5 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
    
                // this.wordsMost = this.arrayNgramsMost(data.ngrams.most)
            })
            .catch(error => console.error(error))
    
    
    },
    template: `
    <div class="prestaFairguest" v-if="fairguestItem.fairguest_counts">
        <header class="fg-header">
            <div class="fg-header__title">
                <div class="fa-3x">
                    <span class="fa-layers fa-fw" style="background:transparent">
                        <i class="fas fa-star"></i>
                        <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11 down-1" style="font-weight:900">{{ fairguestItem.fairguest_counts.weighted_rating|round(1) }}</span>
                    </span>
                </div>
            </div>
            <div class="fg-header__subline">
                {{ fairguestItem.fairguest_counts.rated_count_not_older_than_one_year }} avis client
            </div>
        </header>
        <section class="fg-counts">
            <ul class="fg-bar-chart no-bullet">
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating5 + '%'" style="background-color: #3D8600"></span>
                    <span class="bar-chart__label">Excellent {{ percentageRating5 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating4 + '%'" style="background-color: #71a63e"></span>
                    <span class="bar-chart__label">Très bon {{ percentageRating4 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating3 + '%'" style="background-color: #9fbf04"></span>
                    <span class="bar-chart__label">Bon {{ percentageRating3 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating2 + '%'" style="background-color: #F8A025"></span>
                    <span class="bar-chart__label">Moyen {{ percentageRating2 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating1 + '%'" style="background-color: #E03313"></span>
                    <span class="bar-chart__label">Médiocre {{ percentageRating1 }}%</span>
                </li>
            </ul>
            
        </section>
        <footer>
            <a href="#FairGuest" class="scrollTo button text-center">Voir le détail</a>
        </footer>
    </div>
    `
    };